// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AreaChartOutlinedSvg from "@fishx/icons-svg/es/asn/AreaChartOutlined";
import FishxIcon from '../components/FishxIcon';

var AreaChartOutlined = function AreaChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AreaChartOutlinedSvg
  }));
};

AreaChartOutlined.displayName = 'AreaChartOutlined';
export default React.forwardRef(AreaChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AreaChartOutlined.js
// module id = 2011
// module chunks = 0